"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceTreeView = void 0;
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const TreeView_1 = __importDefault(require("@material-ui/lab/TreeView"));
const Palette_1 = __importDefault(require("@opsbase/lib-palette/Palette/Palette"));
const usePlacesWithAscendants_1 = __importDefault(require("@opsbase/react-gql-hooks/place/usePlacesWithAscendants"));
const Chip_1 = __importDefault(require("@opsbase/web-chips/Chip/Chip"));
const web_css_1 = require("@opsbase/web-css");
const ChevronRightIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ChevronRightIcon"));
const ExpandMoreIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ExpandMoreIcon"));
const Horizontal_1 = require("@opsbase/web-layout/Horizontal");
const SearchBox_1 = __importDefault(require("@opsbase/web-textfield/SearchBox/SearchBox"));
const Checkbox_1 = require("@opsbase/web-ui/Checkbox");
const Dots_1 = __importDefault(require("@opsbase/web-ui/Dots/Dots"));
const defaults_1 = __importDefault(require("lodash/defaults"));
const uniq_1 = __importDefault(require("lodash/uniq"));
const react_1 = __importStar(require("react"));
const makeMyClasses = () => ({
    root: {
        '&.Mui-selected > .MuiTreeItem-content': {
            background: Palette_1.default.secondary.light,
        },
        '&.Mui-selected:focus > .MuiTreeItem-content > .MuiTreeItem-label': {
            background: Palette_1.default.secondary.background,
        },
        '&.MuiTreeItem-root > .MuiTreeItem-content:hover > .MuiTreeItem-label': {
            background: Palette_1.default.secondary.background,
        },
        '@media (hover: none)': {
            backgroundColor: 'transparent',
        },
        maxWidth: 300,
    },
    chip1: {
        height: 20,
        width: 35,
        color: Palette_1.default.WhiteSmoke.main,
        border: '0px',
        backgroundColor: Palette_1.default.positive.main,
        borderRadius: '0px 16px 16px 0px',
    },
    chip2: {
        height: 20,
        width: 35,
        color: Palette_1.default.BlackCoral.main,
        border: '0px',
        backgroundColor: Palette_1.default.InputCardGrey.main,
        borderRadius: '16px 0px 0px 16px',
    },
});
const maxToShow = 6;
exports.PlaceTreeView = react_1.default.memo((props) => {
    const myCss = (0, web_css_1.useCss)(makeMyClasses);
    const { selected, onSelect } = props;
    const selectedLookupMap = selected.reduce((acc, z) => {
        acc[z] = true;
        return acc;
    }, {});
    const [keyword, setKeyword] = (0, react_1.useState)('');
    const [hasSearch, setHasSearch] = (0, react_1.useState)(false);
    const { data, loading } = (0, usePlacesWithAscendants_1.default)({
        variables: {
            limit: 1000,
            keyword: keyword ? [keyword] : [],
        },
    });
    (0, react_1.useEffect)(() => {
        if (!loading)
            setHasSearch(hasSearch || (data === null || data === void 0 ? void 0 : data.length) > maxToShow);
    }, [loading, data, hasSearch]);
    const placesTree = (0, react_1.useMemo)(() => transformPlacesToPlacesTree(data), [data]);
    const getAllChildren = (0, react_1.useCallback)((node, res) => {
        var _a;
        res.push(node);
        (_a = node === null || node === void 0 ? void 0 : node.children) === null || _a === void 0 ? void 0 : _a.map(c => getAllChildren(c, res));
        return res;
    }, []);
    const isSelected = (0, react_1.useCallback)(node => selectedLookupMap[node.id], [selectedLookupMap]);
    // IHS-1348: consumers merely toggle individual nodes
    // we want the parent to select all children.. not toggle
    // so we send only the unselected ones.
    const filterSelectedChildren = (0, react_1.useCallback)((node, res, selectedFlag) => {
        var _a;
        const s = isSelected(node);
        // if we want to select, pick unselected ones. Else pick selected ones.
        // so we always choose only the ones to toggle
        if (selectedFlag ? !s : s)
            res.push(node);
        (_a = node === null || node === void 0 ? void 0 : node.children) === null || _a === void 0 ? void 0 : _a.map(c => filterSelectedChildren(c, res, selectedFlag));
        return res;
    }, [isSelected]);
    const callbacks = (0, react_1.useRef)({});
    const getChangeHandler = (0, react_1.useCallback)(node => {
        const fn = b => {
            onSelect === null || onSelect === void 0 ? void 0 : onSelect(filterSelectedChildren(node, [], b));
        };
        callbacks.current[node] = fn;
        return fn;
    }, [filterSelectedChildren, onSelect]);
    const renderTree = (0, react_1.useCallback)((node) => {
        const selectedChildren = getAllChildren(node, []).filter(c => c.id !== node.id && isSelected(c));
        return (react_1.default.createElement(lab_1.TreeItem, { key: node.id, nodeId: node.id, className: myCss.root, label: react_1.default.createElement(Horizontal_1.Horizontal, { paddingX: true, centered: true },
                react_1.default.createElement(core_1.FormControlLabel, { control: react_1.default.createElement(Checkbox_1.Checkbox, { partChecked: selectedChildren.length, checked: selected.some(item => item === node.id), onChange: getChangeHandler(node) }), label: react_1.default.createElement(react_1.default.Fragment, null, node.title.split(/[>]+/).pop()), key: node.id }),
                node.children.length ? (react_1.default.createElement(Horizontal_1.Horizontal, { shrink: true },
                    react_1.default.createElement(Chip_1.default, { classes: {
                            root: myCss.chip2,
                        }, small: true, color: Palette_1.default.White, tip: node.children.length ? node.children.length : '', label: node.children.length }),
                    react_1.default.createElement(Chip_1.default, { classes: {
                            root: myCss.chip1,
                        }, small: true, color: Palette_1.default.White, tip: selectedChildren.length ? selectedChildren.length : '', label: selectedChildren.length }))) : null) }, Array.isArray(node.children)
            ? node.children.map(childNode => renderTree(childNode))
            : null));
    }, [getAllChildren, getChangeHandler, isSelected, myCss.chip1, myCss.chip2, myCss.root, selected]);
    const hasKeyword = (keyword === null || keyword === void 0 ? void 0 : keyword.length) > 0;
    const expanded = (0, react_1.useMemo)(() => {
        if (hasKeyword) {
            const e = [];
            const findExpanded = (n) => {
                if (n.children.length)
                    e.push(n.id);
                n.children.forEach(findExpanded);
            };
            placesTree === null || placesTree === void 0 ? void 0 : placesTree.forEach(findExpanded);
            return e;
        }
        return [];
    }, [hasKeyword, placesTree]);
    const renderedTree = (0, react_1.useMemo)(() => placesTree === null || placesTree === void 0 ? void 0 : placesTree.map(d => renderTree(d)), [placesTree, renderTree]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        hasSearch && react_1.default.createElement(SearchBox_1.default, { autoFocus: true, keyword: keyword, onChange: setKeyword }),
        loading && react_1.default.createElement(Dots_1.default, { style: { margin: '16px auto' }, color: Palette_1.default.primary }),
        !loading && (react_1.default.createElement(TreeView_1.default, { defaultCollapseIcon: react_1.default.createElement(ExpandMoreIcon_1.default, null), defaultExpanded: expanded, defaultExpandIcon: react_1.default.createElement(ChevronRightIcon_1.default, null) }, renderedTree))));
});
exports.default = exports.PlaceTreeView;
function transformPlacesToPlacesTree(places) {
    let nodes = {};
    return places === null || places === void 0 ? void 0 : places.filter(place => {
        const id = place.id;
        const parentId = place.parentId;
        nodes[id] = (0, defaults_1.default)(place, nodes[id], { children: [] });
        if (parentId) {
            nodes[parentId] = nodes[parentId] || { children: [] };
            nodes[parentId].children.push(place);
            nodes[parentId].children = (0, uniq_1.default)(nodes[parentId].children);
        }
        return !parentId;
    });
}
